export default __webpack_public_path__ + "static/media/plurato-sailfin-thumbnail.2fa0bf3c.png";